import type { NetworkQuality } from '@/services/agora.types';

import { EVENT_HEARTBEAT_INTERVAL } from '@/store/modules/eventHeartbeat/types';

const uplink: number[] = [];
const downlink: number[] = [];

// 2000ms is the interval time with which agora sdk calls network-quality event
const ARRAY_SIZE = EVENT_HEARTBEAT_INTERVAL / 2000;

export function collectNetworkQualityDataPoints(networkQuality: NetworkQuality) {
  if (uplink.length > ARRAY_SIZE) {
    uplink.shift();
  }

  uplink.push(networkQuality.uplinkNetworkQuality);

  if (downlink.length > ARRAY_SIZE) {
    downlink.shift();
  }

  downlink.push(networkQuality.downlinkNetworkQuality);
}

export function getNetworkQualityDatapoints() {
  return {
    uplink,
    downlink
  };
}
